import ContentStorage from '../../tnew/content/ContentStorage';


const key = 'cac7e136-b8dc-4969-854a-45adc14395d1';


function get(name) {
  return ContentStorage.get(key, name);
}


class ForgotPasswordComponent {
  static get successMessage() {
    return get('SuccessMessage');
  }

  static get successMessageSubhead() {
    return get('SuccessMessageSubhead');
  }

  static get emailAddressProvidedLabel() {
    return get('EmailAddressProvidedLabel');
  }

  static get heading() {
    return get('Heading');
  }

  static get cancelButtonText() {
    return get('CancelButtonText');
  }

  static get sendEmailButtonText() {
    return get('SendEmailButtonText');
  }

  static get closeButtonText() {
    return get('CloseButtonText');
  }
}


export default ForgotPasswordComponent;



// WEBPACK FOOTER //
// ./src/account/login/ForgotPasswordComponent.js